define('CustomProductCollection.MainAction.Children.CollectionView', [
    'CustomProductCollection.MainAction.Item.View',
    'custom_product_collection_main_action_row_view.tpl',
    'SCCollectionView'
], function CustomProductCollectionMainActionChildrenCollectionViewModule(
    CustomProductCollectionMainActionItemView,
    template,
    SCCollectionViewComponent
) {
    'use strict';

    var SCCollectionView = SCCollectionViewComponent.SCCollectionView;
    var CELLS_PER_ROW = 1;

    /**
     * Children collection view for CustomProductCollection.
     * Renders a row for each child item and re-renders on selection changes.
     * @constructor
     * @param {Object} options - View options. Must include: collection (Array|Backbone.Collection), model (Backbone.Model)
     */
    function CustomProductCollectionMainActionChildrenCollectionView(options) {
        SCCollectionView.call(this, options.collection);

        this.options = options || {};
        this.template = template;

        this.attributes = {
            id: 'CustomProductCollectionMainActionChildrenCollectionView',
            'class': 'CustomProductCollection-MainAction-Children-CollectionView'
        };

        // Ensure model emits selection events that trigger rerender
        if (this.options.model) {
            this.options.model.on('change:selectedChild', this.render, this);
        }
    }

    // Inherit parent instance methods.
    CustomProductCollectionMainActionChildrenCollectionView.prototype = Object.create(
        SCCollectionView.prototype
    );
    CustomProductCollectionMainActionChildrenCollectionView.prototype.constructor =
        CustomProductCollectionMainActionChildrenCollectionView;

    /**
     * Returns the number of cell views per row.
     * @returns {number}
     */
    CustomProductCollectionMainActionChildrenCollectionView.prototype.getCellViewsPerRow =
        function getCellViewsPerRow() {
            return CELLS_PER_ROW;
        };

    /**
     * Returns a new item view instance for a given child.
     * @param {Object} item - Item data for a child.
     * @returns {CustomProductCollectionMainActionItemView}
     */
    CustomProductCollectionMainActionChildrenCollectionView.prototype.getCellViewInstance =
        function getCellViewInstance(item) {
            return new CustomProductCollectionMainActionItemView({
                item: item,
                model: this.options.model
            });
        };

    /**
     * Returns the context object for the row view template.
     * @returns {Object}
     */
    CustomProductCollectionMainActionChildrenCollectionView.prototype.getContext =
        function getContext() {
            return {};
        };

    CustomProductCollectionMainActionChildrenCollectionView.prototype.render = function render() {
        var restoreFocusElement;
        var y = window.scrollY;

        SCCollectionView.prototype.render.apply(this, arguments);

        requestAnimationFrame(function revertScroll() {
            window.scrollTo(0, y);
        });

        if (this.options.model.get('childIdToRestoreFocus')) {
            restoreFocusElement = this.$(
                '[data-action="select-child"][data-child-id="' +
                    this.options.model.get('childIdToRestoreFocus') +
                    '"]'
            )[0];
            if (restoreFocusElement) {
                restoreFocusElement.focus();
            }
            this.options.model.set('childIdToRestoreFocus', null);
        }
    };

    // Return the AMD constructor.
    return CustomProductCollectionMainActionChildrenCollectionView;
});
